export const POST_LOGIN_RETURN_URL_PARAM = "returnUrl";

const DEFAULT_POST_LOGIN_PATH = "/galaxyHome";

/**
 * Validates an in-app path for post-login navigation (open-redirect safe).
 * @param {string|null|undefined} value
 * @returns {string|null}
 */
export const getSafePostLoginPath = (value) => {
  if (value == null || typeof value !== "string") {
    return null;
  }

  let path = value.trim();
  if (!path) {
    return null;
  }

  try {
    path = decodeURIComponent(path);
  } catch {
    return null;
  }

  path = path.trim();
  if (!path.startsWith("/") || path.startsWith("//")) {
    return null;
  }

  if (path.includes("://") || path.includes("\\")) {
    return null;
  }

  const pathOnly = path.split("?")[0].split("#")[0];
  if (pathOnly === "/" || pathOnly === "/login") {
    return null;
  }

  return path;
};

export const getPostLoginDestination = (searchParams) => {
  const raw =
    searchParams?.get(POST_LOGIN_RETURN_URL_PARAM) ||
    searchParams?.get("redirect") ||
    "";
  return getSafePostLoginPath(raw) || DEFAULT_POST_LOGIN_PATH;
};

export const buildLoginPathWithReturnUrl = (pathname, search = "") => {
  const target = `${pathname || ""}${search || ""}`;
  const safe = getSafePostLoginPath(target);
  if (!safe) {
    return "/login";
  }
  return `/login?${POST_LOGIN_RETURN_URL_PARAM}=${encodeURIComponent(safe)}`;
};
